import { useEffect, useState, useCallback } from "react";

// Custom hook to get window size
export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 1200,
    height: typeof window !== 'undefined' ? window.innerHeight : 800,
  });

  useEffect(() => {
    // Only run in browser environment
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Set initial size
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

// Custom hook for responsive collapse
export const useResponsiveCollapse = () => {
  const { width } = useWindowSize();
  const [expandedRows, setExpandedRows] = useState(new Set());

  const isMobile = width < 768; // Bootstrap md breakpoint

  // Use useCallback to memoize the toggle function
  const toggleRow = useCallback((rowId) => {
    
    setExpandedRows(prev => {
      const newSet = new Set(prev);
      if (newSet.has(rowId)) {
        newSet.delete(rowId);
      } else {
        newSet.add(rowId);
      }
      return newSet;
    });
  }, []);

  const isExpanded = useCallback((rowId) => {
    return expandedRows.has(rowId);
  }, [expandedRows]);

  return { isMobile, toggleRow, isExpanded, windowWidth: width };
};